import { SecondaryProductSummarySkeleton } from 'components/secondaryMarket/shared/sections/SecondaryProductSummary.skeleton';
import { SecondaryTradeInformationSkeleton } from 'components/secondaryMarket/shared/sections/SecondaryTradeInformation.skeleton';
import { FC } from 'react';

import { CpOrderBookingInformationSkeleton } from './blocks/bookingInformation/cpOrderBookingInformation.skeleton';
import { CpOrderSalesMarginInformationSkeleton } from './blocks/salesMarginInformation/cpOrderSalesMarginInformation.skeleton';

export const CpOrderFormContentSkeleton: FC = () => (
  <>
    <SecondaryProductSummarySkeleton />
    <SecondaryTradeInformationSkeleton />
    <CpOrderSalesMarginInformationSkeleton />
    <CpOrderBookingInformationSkeleton />
  </>
);
